import * as types from './sampleActionTypes';

// Get Sample
export const getSampleRequest = (payload) =>
    ({ type: types.GET_SAMPLE_REQUEST, payload });
export const getSampleSuccess = (payload) =>
    ({ type: types.GET_SAMPLE_SUCCESS, payload });
export const getSampleError = (payload) =>
    ({ type: types.GET_SAMPLE_ERROR, payload });

// Get Sample List with Filter
export const getSampleListRequest = (payload) =>
    ({ type: types.GET_SAMPLE_LIST_REQUEST, payload });
export const getSampleListSuccess = (payload) =>
    ({ type: types.GET_SAMPLE_LIST_SUCCESS, payload });
export const getSampleListError = (payload) =>
    ({ type: types.GET_SAMPLE_LIST_ERROR, payload });

// Add Sample
export const addSampleRequest = (payload) =>
    ({ type: types.ADD_SAMPLE_REQUEST, payload });
export const addSampleSuccess = (payload) =>
    ({ type: types.ADD_SAMPLE_SUCCESS, payload });
export const addSampleError = (payload) =>
    ({ type: types.ADD_SAMPLE_ERROR, payload });

// Update Sample
export const updateSampleRequest = (payload) =>
    ({ type: types.UPDATE_SAMPLE_REQUEST, payload });
export const updateSampleSuccess = (payload) =>
    ({ type: types.UPDATE_SAMPLE_SUCCESS, payload });
export const updateSampleError = (payload) =>
    ({ type: types.UPDATE_SAMPLE_ERROR, payload });

// Delete Sample
export const deleteSampleRequest = (payload) =>
    ({ type: types.DELETE_SAMPLE_REQUEST, payload });
export const deleteSampleSuccess = (payload) =>
    ({ type: types.DELETE_SAMPLE_SUCCESS, payload });
export const deleteSampleError = (payload) =>
    ({ type: types.DELETE_SAMPLE_ERROR, payload });

// Get Sample Dropdown
export const getSampleDropdownRequest = (payload) =>
    ({ type: types.GET_SAMPLE_DROPDOWN_REQUEST, payload });
export const getSampleDropdownSuccess = (payload) =>
    ({ type: types.GET_SAMPLE_DROPDOWN_SUCCESS, payload });
export const getSampleDropdownError = (payload) =>
    ({ type: types.GET_SAMPLE_DROPDOWN_ERROR, payload });

// Add Sample Color
export const addSampleColorRequest = (payload) =>
    ({ type: types.ADD_SAMPLE_COLOR_REQUEST, payload });
export const addSampleColorSuccess = (payload) =>
    ({ type: types.ADD_SAMPLE_COLOR_SUCCESS, payload });
export const addSampleColorError = (payload) =>
    ({ type: types.ADD_SAMPLE_COLOR_ERROR, payload });

// Get Sample Colors
export const getSampleColorsRequest = (payload) =>
    ({ type: types.GET_SAMPLE_COLORS_REQUEST, payload });
export const getSampleColorsSuccess = (payload) =>
    ({ type: types.GET_SAMPLE_COLORS_SUCCESS, payload });
export const getSampleColorsError = (payload) =>
    ({ type: types.GET_SAMPLE_COLORS_ERROR, payload });

// Update Sample Color
export const updateSampleColorRequest = (payload) =>
    ({ type: types.UPDATE_SAMPLE_COLOR_REQUEST, payload });
export const updateSampleColorSuccess = (payload) =>
    ({ type: types.UPDATE_SAMPLE_COLOR_SUCCESS, payload });
export const updateSampleColorError = (payload) =>
    ({ type: types.UPDATE_SAMPLE_COLOR_ERROR, payload });

// Delete Sample Color
export const deleteSampleColorRequest = (payload) =>
    ({ type: types.DELETE_SAMPLE_COLOR_REQUEST, payload });
export const deleteSampleColorSuccess = (payload) =>
    ({ type: types.DELETE_SAMPLE_COLOR_SUCCESS, payload });
export const deleteSampleColorError = (payload) =>
    ({ type: types.DELETE_SAMPLE_COLOR_ERROR, payload });

// Create Sample with Colors (composite action)
export const createSampleWithColorsRequest = (payload) =>
    ({ type: types.CREATE_SAMPLE_WITH_COLORS_REQUEST, payload });
export const createSampleWithColorsSuccess = (payload) =>
    ({ type: types.CREATE_SAMPLE_WITH_COLORS_SUCCESS, payload });
export const createSampleWithColorsError = (payload) =>
    ({ type: types.CREATE_SAMPLE_WITH_COLORS_ERROR, payload });

// Create Weave from Sample
export const createWeaveFromSampleRequest = (payload) =>
    ({ type: types.CREATE_WEAVE_FROM_SAMPLE_REQUEST, payload });
export const createWeaveFromSampleSuccess = (payload) =>
    ({ type: types.CREATE_WEAVE_FROM_SAMPLE_SUCCESS, payload });
export const createWeaveFromSampleError = (payload) =>
    ({ type: types.CREATE_WEAVE_FROM_SAMPLE_ERROR, payload });
